import { Reveal } from "../Reveal";
import { BookButton, DisclaimerNote } from "../Cta";

export const FinalCTA = () => (
  <section className="bg-night text-paper" data-testid="final-cta-section">
    <div className="mx-auto max-w-6xl px-5 md:px-8 py-32 md:py-48">
      <Reveal>
        <h2 className="font-serif text-4xl md:text-6xl tracking-tight leading-[1.05]" data-testid="final-heading">
          Let’s walk it through.
        </h2>
      </Reveal>
      <Reveal delay={0.12}>
        <p className="mt-8 text-base md:text-lg tracking-wide text-paper/60">
          30 minutes. £60. Phone call.
        </p>
      </Reveal>
      <Reveal delay={0.2}>
        <p className="mt-4 text-base md:text-lg text-paper/60">
          You can walk. I can walk. Neither of us has to.
        </p>
      </Reveal>
      <Reveal delay={0.28}>
        <div className="mt-12">
          <BookButton label="Book a First Walk" testid="final-book-cta" dark />
        </div>
        <DisclaimerNote dark className="mt-6" testid="final-cta-disclaimer" />
      </Reveal>
    </div>
  </section>
);
